import styled from 'styled-components';
import { themeColor } from '@amsterdam/asc-ui/lib/utils';

export const AppStyles = styled.div`
	padding: 20px;
	background: ${themeColor('tint', 'level4')};
	display: flex;
	gap: 10px;
`;
